import { supabase } from "@/lib/supabase";

/**
 * V2-13: notification preferences API wrapper for the
 * user_notification_preferences table seeded in V2-5. Reads use the
 * row-level-secured SELECT policy; writes go through the
 * upsert_notification_preferences security-definer RPC so creating
 * the row on first save doesn't need separate insert plumbing.
 */
export interface NotificationPreferences {
  opted_out_types: string[];
  digest_mode: boolean;
  timezone: string;
}

export async function fetchMyNotificationPreferences(): Promise<NotificationPreferences> {
  const { data, error } = await supabase
    .from("user_notification_preferences")
    .select("opted_out_types, digest_mode, timezone")
    .maybeSingle();
  if (error) throw new Error(error.message);
  return {
    opted_out_types: (data?.opted_out_types as string[] | null) ?? [],
    digest_mode: Boolean(data?.digest_mode),
    timezone:
      (data?.timezone as string | null) ||
      (typeof Intl !== "undefined"
        ? (Intl.DateTimeFormat().resolvedOptions().timeZone ?? "UTC")
        : "UTC"),
  };
}

export async function saveMyNotificationPreferences(
  prefs: NotificationPreferences,
): Promise<void> {
  const { error } = await supabase.rpc("upsert_notification_preferences", {
    p_opted_out_types: prefs.opted_out_types,
    p_digest_mode: prefs.digest_mode,
    p_timezone: prefs.timezone,
  });
  if (error) throw new Error(error.message);
}
